import React, { useState, useEffect, useMemo, memo } from "react";
import DataTable from "react-data-table-component";
import apiCaller from "../../api/ApiCaller";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import SingleParameterValidation from "../parameterValidationMaster/SingleParameterValidation";

// Row content when expanded


const ExpandRowPaginationTable = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [expandedRow, setExpandedRow] = useState(null);
    const [columns, setColumns] = useState(useMemo(() => [], []));

    const ExpandedComponent = () => {
        return (
            <div style={{padding:"10px",background:"#f9f9f9"}}>
                <SingleParameterValidation data={expandedRow} />
            </div>
        );
    };

    const customStyles = {
        rows: {
            style: {
                overflow: "visible !important",
                width: "auto",
            },
        },
        headCells: {
            style: {
                minWidth: "153px !important",
            },
        },
        cells: {
            style: {
                overflow: "visible !important",
                minWidth: "153px !important",
            },
        },
    };

    const handleRowExpandToggle = (row) => {
        setExpandedRow((prev) => (prev?.id === row?.id ? null : row));
    };

    useEffect(() => {
        const expandColumn = {
            name: '',
            width: '120px',
            cell: (row) => (
                <div
                    onClick={() => handleRowExpandToggle(row)}
                    style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        color: '#007bff',
                        fontWeight: '500',
                    }}
                >
                    <span>Validations</span>
                    {expandedRow?.id === row?.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        };

        setColumns([expandColumn, ...props.columns]);
        fetchData(currentPage);
    }, [props.columns, expandedRow,props?.drawCount]);

    const callPostApi = (url, data, headerMap, successCallBack, failedCallBack) => {
        apiCaller.callPostApi(url, data, headerMap, successCallBack, failedCallBack);
    };

    const fetchData = async (page, size = perPage) => {
        setLoading(true);
        const jsonRequest = {
            page: page - 1,
            size: size,
            searchFilters: props.filters?.searchFilters || [],
            sortRules: props.filters?.sortRules || [],
        };
        callPostApi(props.paginationUrl, jsonRequest, {}, (response) => {
            setData(response?.data || []);
            setTotalRows(response.totalItems);
            setLoading(false);
        }, (error) => {
            setLoading(false);
            console.error(error);
        });
    };

    const handlePageChange = (page) => {
        fetchData(page);
        setCurrentPage(page);
    };

    const handleChange = ({ selectedRows }) => {        
        props.setDeleteAbleRowsData?.(selectedRows);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(1, newPerPage);
        setPerPage(newPerPage);
        setExpandedRow(null);
    };

    return (
        <DataTable
            className="pagination-data-table"
            title=""
            columns={columns}
            data={data}
            pagination={props.paginationStatus}
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            customStyles={customStyles}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            persistTableHead
            selectableRows={props.selectedAble}
            onSelectedRowsChange={props.selectedAble ? handleChange : undefined}
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            expandableRowExpanded={(row) => row.id === expandedRow?.id}
            expandableRowsHideExpander   // ✅ Hide default arrow
            expandOnRowClicked={false}   // ✅ Don't expand on full row click
        />
    );
    
};

export default memo(ExpandRowPaginationTable);
